import { CSSObject } from '@chakra-ui/react';

export const BoxResultedWrapper: CSSObject = {
  px: '2',
  border: '2px',
  borderColor: 'beta.500',
  bg: 'white',
  borderRadius: 'md',
  mb: '2',
  flex: '1',
};

export const FlexEventRule: CSSObject = {
  color: 'gray.500',
};

export const RunnerResultRow: CSSObject = {
  borderStyle: ['solid', null, 'dashed'],
  borderColor: 'blackAlpha.300',
  py: '1.5',
  h: '12',
};

export const RunnerDetails: CSSObject = {
  gap: '2',
};

export const RunnerPlace: CSSObject = {
  borderRadius: 'base',
  bgGradient: 'linear(to-b, beta.400, beta.600)',
  color: 'yellow.900',
  fontSize: '2xs',
  '&&': {
    h: '6',
    w: '8',
  },
  border: 'none',
};

export const RunnerNumber: CSSObject = {
  fontWeight: 'bold',
  fontSize: 'xs',
  color: 'gray.700',
};

export const RunnerOddsContainer: CSSObject = {
  gap: '1',
};

export const RunnerOdds: CSSObject = {
  w: '12',
  h: '8',
  borderWidth: '2px',
  borderStyle: 'solid',
  borderColor: 'white',
  bg: 'gray.300',
  borderRadius: 'md',
  color: 'blackAlpha.400',
  fontWeight: 'bold',
  fontSize: 'sm',
  boxShadow:
    '0px 0px 0px 2px rgba(0, 0, 0, 0.20) inset, 0px 2px 6px 0px rgba(0, 0, 0, 0.35)',
};

export const Heading: CSSObject = {
  textTransform: 'capitalize',
  color: 'gray.700',
  fontSize: 'xs',
  fontWeight: 'medium',
  py: '2',
};

export const WinPlaceHeader: CSSObject = {
  py: '0',
  w: '12',
  color: 'gray.700',
};

export const RaceResultsHeader: CSSObject = {
  color: 'gray.700',
};
